exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".screenshot-frame[data-v-8bf43000]{position:relative;margin-right:8px;width:130px!important;height:130px!important;background-size:cover!important;background-repeat:no-repeat!important;background-position:50%!important;flex:none}.clickable[data-v-8bf43000]{cursor:pointer;position:absolute;height:100px;width:130px;top:30px}.delete-button[data-v-8bf43000]{position:absolute;right:-7px;top:-7px;width:21px;height:21px;border-radius:50%;background:#000;outline:none;border:none;line-height:1.1;z-index:9}.screenshot-container[data-v-8bf43000]{overflow-y:auto}", ""]);

// exports
